module.exports = __webpack_public_path__ + "static/img/hos-def-logo.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/hos-def-logo.png
// module id = 103
// module chunks = 0